export default class USText {
    static US = {
        organisation: 'organization',
        organisations: 'organizations',
        cheque: 'check',
    }
}